import axios from "axios";
import { api } from "./api_route";


export const allOrganizationNotice = async (payload) => {
  try {
    const response = await axios.get(`${api}/noticeTemplates/all`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const organizationNoticeTemplate = async (params) => {
  try {
    const response = await axios.get(`${api}/noticeTemplates/all/${params ? params : ''}`);
    return response;
  } catch (error) {
    throw error;
  }
};



export const saveNoticeSection = async (payload) => {
  try {
    const response = await axios.post(`${api}/noticeTemplates/save/${payload.templateId}`,payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createAndUpdateNoticeSection = async (payload) => {
  try {
    const response = await axios.post(`${api}/noticeTemplates/createAndUpdate${payload.templateId ? `/${payload.templateId}` : ""}`,payload);
    return response;
  } catch (error) {
    throw error;
  }
};


export const viewNotice = async (id) => {
  try {
    const response = await axios.get(`${api}/noticeTemplates/notice/${id}`,
      {
    responseType: "blob",
  }
);
  
    return response.data; 
  } catch (error) {
    throw error;
  }
};

export const previewNotice = async (values) => {
  try {
    const response = await axios.post(
      `${api}/noticeTemplates/preview`,
      values,
      {
        responseType: "blob", 
      }
    );

  
    return response.data; 
  } catch (error) {
    throw error;
  }
};


// Notice Source Images



export const createNoticeSrcImages = async (formData) => {
  try {
    const response = await axios.post(
      `${api}/noticeTemplates/createNoticeSrcImages`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        
        timeout: 300000, 
      }
    );

   
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
  }
};


export const getAllNoticeSrcImages = async (values) => {
  try {
   const response = await axios.get(
  `${api}/noticeTemplates/getAllNoticeSrcImages`);

   
    return response; 
  } catch (error) {
    throw error;
  }
};
